import { render } from "./Letter.vue?vue&type=template&id=c180a8f8&scoped=true"
import script from "./Letter.vue?vue&type=script&lang=ts"
export * from "./Letter.vue?vue&type=script&lang=ts"

import "./Letter.vue?vue&type=style&index=0&id=c180a8f8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c180a8f8"

export default script